import React from 'react';
import { Link, useParams } from 'react-router-dom';
import INSIGHTS from '../data/insights';
import MarkdocRenderer from '../components/MarkdocRenderer';

function formatCategory(value) {
  return value
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function formatDate(value) {
  if (!value) {
    return '';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

function isExternalUrl(value) {
  return /^https?:\/\//i.test(value || '');
}

export default function InsightDetail() {
  const { slug } = useParams();
  const insight = INSIGHTS.find((entry) => entry.slug === slug) || null;

  if (!insight) {
    return (
      <section className="section" style={{ textAlign: 'center', padding: '120px 0' }}>
        <div className="container">
          <h2>Insight Not Found</h2>
          <p>The article you are looking for does not exist.</p>
          <Link to="/insights" className="btn btn-primary" style={{ marginTop: 24, display: 'inline-flex' }}>
            Back to Insights
          </Link>
        </div>
      </section>
    );
  }

  const contentText = insight.content || '';
  const coverImageInContent = Boolean(
    insight.coverImage && contentText.includes(`(${insight.coverImage})`)
  );
  const hasInlineCtaSection = /\{%\s*(cards|ctaBand)\b/i.test(contentText);
  const shouldShowDefaultCta = Boolean(insight.ctaText && insight.ctaLink && !hasInlineCtaSection);

  return (
    <section className="section section-soft article-page">
      <div className="container article-wrap">
        <Link to="/insights" className="article-back">
          <span aria-hidden="true">←</span>
          <span>Back to Insights</span>
        </Link>

        <article className="article-hero article-hero--full">
          <span className="insight-tag">{formatCategory(insight.category || 'technology')}</span>
          <h1>{insight.title}</h1>
          <p className="article-meta">
            {insight.author}
            {insight.publishedDate ? ` · ${formatDate(insight.publishedDate)}` : ''}
          </p>
          {insight.excerpt ? <p className="article-subtitle">{insight.excerpt}</p> : null}

          {insight.coverImage && !coverImageInContent ? (
            <figure className="article-markdoc-cover">
              <img src={insight.coverImage} alt={insight.title} />
            </figure>
          ) : null}

          <MarkdocRenderer content={insight.content} />

          {shouldShowDefaultCta ? (
            <section className="article-cta">
              <h2>{insight.ctaText}</h2>
              <p>
                {isExternalUrl(insight.ctaLink) ? (
                  <a href={insight.ctaLink} className="article-cta-link" target="_blank" rel="noreferrer">
                    {insight.ctaText}
                  </a>
                ) : (
                  <Link to={insight.ctaLink} className="article-cta-link">
                    {insight.ctaText}
                  </Link>
                )}
              </p>
            </section>
          ) : null}
        </article>
      </div>
    </section>
  );
}
